var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRolling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.945,
    height: 35.484,
    viewBox: "0 0 35.945 35.484",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rolling",
    transform: "translate(0 1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bed-svgrepo-com",
    transform: "translate(0 10.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_960",
    "data-name": "Group 960",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_959",
    "data-name": "Group 959"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M16.529,143.806a2.324,2.324,0,0,1-2.017-2.485c-.018-.577-.021-1.159-.008-1.76H8.8a2.341,2.341,0,0,0,.435-1.39,1.84,1.84,0,0,0-1.577-2.02H7.639A2.99,2.99,0,0,0,9.515,133.2c.024-1.7-1.03-3.1-2.355-3.131s-2.419,1.32-2.443,3.018a3.022,3.022,0,0,0,1.873,3.057H3.695V125.857a.932.932,0,0,0-.8-1.023H.8a.932.932,0,0,0-.8,1.023L.014,145.6A1.15,1.15,0,0,0,1,146.864H2.717v.74a.746.746,0,0,0,.639.819h3.2A.746.746,0,0,0,7.2,147.6v-.74H28.646v.74a.746.746,0,0,0,.639.819h3.2a.746.746,0,0,0,.639-.819v-.74h1.509a1.15,1.15,0,0,0,.985-1.263v-1.812C32.169,143.791,17.685,143.806,16.529,143.806Z",
    transform: "translate(0 -124.834)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_962",
    "data-name": "Group 962",
    transform: "translate(9.875 5.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_961",
    "data-name": "Group 961",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M158.473,187.861h0a1.1,1.1,0,0,0-1.694-.5h0l-3.619,2.8-4.255-2.44,2,.441a21.465,21.465,0,0,1,.987-2.928l-4.631-.106a1.964,1.964,0,0,0-1.754,2.116l-.056,3.844a2,2,0,0,0,1.691,2.2l2.939.067q.024-.357.055-.7l-2.1-2.038,4.7,2.694a1.027,1.027,0,0,0,1.161-.091l4.18-3.239A1.778,1.778,0,0,0,158.473,187.861Z",
    transform: "translate(-145.447 -185.133)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_964",
    "data-name": "Group 964",
    transform: "translate(14.695 4.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_963",
    "data-name": "Group 963",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M244.7,180.58c-4.678-1.69-12.231-2.94-15.063-2.84a14.369,14.369,0,0,0-1.682,4.055l.5.11,3.236-2.508a2.15,2.15,0,0,1,3.321.977,3.487,3.487,0,0,1-.781,4.155l-4.18,3.239a1.965,1.965,0,0,1-2.508,0l-.439-.426c-.038.783-.048,1.61-.02,2.488a.7.7,0,0,0,.618.744h19.555a.679.679,0,0,0,.611-.65l.395-3.038A5.776,5.776,0,0,0,244.7,180.58Z",
    transform: "translate(-227.063 -177.735)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(26.655 -1) rotate(76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Core",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "rotate-right",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M11.18,4.375,6.805,0V3.014a7.736,7.736,0,0,0,0,15.36V16.43a5.815,5.815,0,0,1,0-11.472V8.749L11.18,4.375Z",
    fill: "#fff",
    fillRule: "evenodd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRolling);
export default __webpack_public_path__ + "static/media/rolling.cb3e60071f6bd6dff519dca9eb1b12a7.svg";
export { ForwardRef as ReactComponent };